import { render } from "./TexteditorView.vue?vue&type=template&id=90a203ac&scoped=true"
import script from "./TexteditorView.vue?vue&type=script&lang=js"
export * from "./TexteditorView.vue?vue&type=script&lang=js"

import "./TexteditorView.vue?vue&type=style&index=0&id=90a203ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90a203ac"]])

export default __exports__